const LOCK_VIEW = 'LOCK_VIEW';

const updateLockView = (state = {}, action) => {
    const { type = null, lockView = false, videoPlaying = '' } = action;
    if (type === LOCK_VIEW) {
        if (lockView) {
            return {
                ...state,
                lockView: true,
                videoPlaying
            }
        } else {
            // we need to check if the video that is paused is the video that is playing, not previous ones
            if (videoPlaying === state?.videoPlaying) {
                return {
                    ...state,
                    lockView: false
                }
            }
        }
        
    }

    return state;
};

export default updateLockView;
